/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Mentions_No_AccessInputs */

const en_notes_mentions_no_access = /** @type {(inputs: Notes_Mentions_No_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No case access`)
};

const pt_br2_notes_mentions_no_access = /** @type {(inputs: Notes_Mentions_No_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem acesso ao caso`)
};

/**
* | output |
* | --- |
* | "No case access" |
*
* @param {Notes_Mentions_No_AccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_mentions_no_access = /** @type {((inputs?: Notes_Mentions_No_AccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Mentions_No_AccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_mentions_no_access(inputs)
	return pt_br2_notes_mentions_no_access(inputs)
});